import {ref} from "vue";
import {defineStore} from "pinia";
import {User} from "@/types";

export const userUserStore = defineStore(
    "user",
    () => {
        const id = ref(0);
        const token = ref("");
        const name = ref("");
        const status = ref(1);
        const type = ref(-1)
        const setUser = (data: User) => {
            id.value = data.id;
            token.value = data.token;
            name.value = data.name;
            status.value = data.status;
            type.value = data.type;
        }
        const reset = () => {
            id.value = 0;
            token.value = "";
            name.value = "";
            status.value = 1;
            type.value = -1;
        }
        return {id, token, name, status, type, setUser, reset};
    },
    {
        persist: true,
    }
);
